import template from 'text!./wizard-errors.html';
import controller from './WizardErrorsCtrl';

export default {
    template,
    bindings: {
        types: '@?'
    },
    controller
};
